import { render, staticRenderFns } from "./Products_ProductItem.vue?vue&type=template&id=125a52fe&scoped=true&"
import script from "./Products_ProductItem.vue?vue&type=script&lang=js&"
export * from "./Products_ProductItem.vue?vue&type=script&lang=js&"
import style0 from "./Products_ProductItem.vue?vue&type=style&index=0&id=125a52fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125a52fe",
  null
  
)

export default component.exports